let isTouch;

window.addEventListener(
  'touchstart',
  function setIsTouch() {
    isTouch = true;
    // Remove event listener once fired, otherwise it'll kill scrolling
    // performance
    window.removeEventListener('touchstart', setIsTouch);
  },
  false
);
